import React from 'react';
import { Box, Typography } from '@mui/material';
import VideoContent from '../UIKit/VideoContent';
import { useTranslation } from 'react-i18next';

const LessonVideoSection = ({ lesson }) => {
  const { t } = useTranslation(['lessons']);

  if (!lesson?.videoUrl) return null;

  return (
    <Box
      sx={{
        mb: 4,
        borderRadius: '12px',
        overflow: 'hidden',
        backgroundColor: 'background.paper',
        border: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Box sx={{ p: 3, pb: 0 }}>
        <Typography variant="h6" component="h3" sx={{ mb: 2, fontWeight: 600 }}>
          {t('lessons:lessonDetail.content.titles.videoTitle')}
        </Typography>
      </Box>
      
      <Box sx={{ p: 3, pt: 0 }}>
        <VideoContent
          options={{ videoUrl: lesson.videoUrl }}
          withMargin={false}
        />
      </Box>
    </Box>
  );
};

export default LessonVideoSection;


